import type { JSX, PropsWithChildren } from 'react';

import { useFocusFallbackListener } from './hooks';

export function FocusFallbackListener({ children }: PropsWithChildren<EmptyProps>): JSX.Element {
	useFocusFallbackListener();

	return <>{children}</>;
}
